


































































import { Component, Vue, Prop, Watch, PropSync, Emit } from "vue-property-decorator";
import { Loader, LoaderOptions } from "@googlemaps/js-api-loader";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import {} from "googlemaps";
import gmapsStyle from "./gmaps-style.json";
import MarkerClustererPlus from '@google/markerclustererplus';
import { initalizeGoogleMaps } from '@/services/maps/index';
import ResizeObserver from 'resize-observer-polyfill';
import * as metadataService from '@/services/metadata/index';
import ImagesTab from './image-plotter/ImagesTab.vue';
import {FarmAnalysisResult} from "@/api/results/types";

@Component({
  name: "PolygonViewer",
  components: {
    AgroIcon: AgroIcons,
    ImageTab: ImagesTab
  }
})
export default class PolygonViewer extends Vue {
  /* A google maps implementation */
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop(String)
  farmAnalysisUuid?: string;

  @Prop({ type: String, default: "base-style" })
  private mapClass!: string;

  @Prop(Object)
  private polygon?: GeoJSON.GeoJSON;

  @Prop(String)
  private labelProperty?: string;

  @Prop(Array)
  private extraPolygons?: Object[];

  @Prop({ type: String, required: true })
  private idProperty!: string;

  @Prop({ type: Boolean, default: false })
  private selectable!: boolean;

  @Prop({ type: Array, default: () => [] })
  private selected!: any[];

  @Prop({ type: Boolean, default: false })
  private downloadable!: boolean;

  @Prop({ type: Boolean, default: false})
  private noControls!: boolean;
  
  @Prop({ type: Boolean, default: true})
  private showImageTabs!: boolean;
  
  @Prop({ type: Boolean, default: false})
  private showMapBiomasIcon!: boolean;
  
  private imageZIndex = 20000;
  public wrappedMap: google.maps.Map<Element> | null = null;
  private attachedLabelsCluster: MarkerClustererPlus | null = null;
  private featuresSelected: any[] = [];
  private featuresSelectedSet: Set<any> = new Set();
  private listeners: google.maps.MapsEventListener[] = [];
  private coordinatesString: string = "";
  private ro: ResizeObserver | null = null;
  private mapSignal = false;
  private lastSize = 0;
  private readyToShow = false;
  private loaded = false;
  private lastBoundedSize = 0;

  private initialized = false;

  private rvo: ResizeObserver | null = null;
  private visible = false;

  private get showLabel() {
    return this.$store.state.metadata.showLabelMarker;
  }

  private get mapStyle() {
    const style = [this.mapClass];
    if (this.disabled) {
      style.push("is-disabled");
    }
    return style;
  }

  private get hasOtherControls() {
    return !!this.downloadable;
  }

  private async mounted() {
    this.observeVisibility();
  }

  private observeVisibility() {
    this.rvo = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const minSize = Math.min(width, height);

        this.visible = minSize !== 0;
      }
      
    })
    this.rvo.observe(this.$refs.mapElement as HTMLDivElement);
  }

  @Watch('visible', { immediate: true })
  private async initializeWhenVisible(visible: boolean) {
    if (visible && !this.initialized) {
      this.initialized = true;
      await initalizeGoogleMaps(this.initMap);
      if (!!this.rvo) {
        this.rvo.disconnect();
        this.rvo = null;
      }
    }
  }

  @Watch('extraPolygons')
  private watchExtraPolygons() {
    this.removeExtraPolygons();
    this.attachExtraPolygons();
    this.attachExtraPolygonsLegend();
  }

  private removeExtraPolygons() {
    this.wrappedMap!.data.forEach(feature => {
      if (feature.getId() != null && feature.getId().toString().startsWith('extraPolygons')) {
        this.wrappedMap!.data.remove(feature);
      }
    });
  }

  private isGoogleMapsLoaded() {
    return typeof window.google !== 'undefined';
  }

  private attachExtraPolygons() {
    let i = 1;
    const infractions: any[] = [];    

    this.extraPolygons?.filter(it => it !== null)
      .map((it: any) => it['polygon']) 
      .forEach((it: any) => it.features
        .forEach((element: any) => {
          element.properties['id'] = 'extraPolygons_' + i;
          if (element.properties.area > 0) {
            infractions.push(element);
          } 
          i += 1;
        })
      );
    this.extraPolygons?.filter(it => it !== null)
      .map((it: any) => it['polygon']) 
      .forEach((it: any) => this.loadPolygon(it, 'id', false));

    setTimeout(() => {
      infractions.forEach(it => this.wrappedMap?.data.overrideStyle(this.wrappedMap?.data.getFeatureById(it.properties['id']), {zIndex: 1000}));
    }, 2000);
  }

  private attachExtraPolygonsLegend() {
    const legend = document.getElementById("legend");
    this.wrappedMap!!.controls[google.maps.ControlPosition.LEFT_TOP].clear();
    if (legend) {
      legend!!.innerHTML = '';
      this.extraPolygons?.filter(it => it !== null)
        .map((it: any) => it['legend']) 
        .forEach((itArr: any[]) => {
          for (const at in itArr) {
            const it = itArr[at]
            const div = document.createElement("div");
            div.innerHTML = `
              <div style='margin-top: 3px; margin-left: 5px'>
                <span style="display: inline-block; width: 1.2em; height: 1.2em; border-radius: 50%; vertical-align: middle; background: ${it['color']}"></span>
                <span style="font-size: 14px">${it['label']}</span>
              </div>
            `
            legend!!.appendChild(div);    
          }
        });
      this.wrappedMap!!.controls[google.maps.ControlPosition.LEFT_TOP].push(legend!!);
    }
  }

  private initMap() {
    const mapOptions: google.maps.MapOptions = {
      center: {
        lat: 0,
        lng: 0,
      },
      zoom: 3,
      zoomControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      mapTypeId: "hybrid",
      styles: gmapsStyle as google.maps.MapTypeStyle[],
    };

    this.wrappedMap = new window.google.maps.Map(
      this.$refs.mapElement as Element,
      mapOptions
    );

    window.google.maps.event.addListenerOnce(this.wrappedMap!, 'tilesloaded', () => {
      setTimeout(async () => { 
        this.loaded = true;

        this.boundToPolygon();
        this.mapSignal = (this.lastSize === 0);
      }, 300);
    });

    this.addFitBoundsListener();
    this.addHandlerSelectFeature();
    this.setupPolygonStyle();

    if (!this.noControls) {
      requestAnimationFrame(async () => {
        this.initCoordinatesLabel(this.$refs.coordinateLabel as HTMLElement);
        this.placeMapControls();
        
        window.google.maps.event.addListenerOnce(this.wrappedMap!, 'tilesloaded', () => {
          this.readyToShow = true;
        });
      });
    }

    if (!!this.polygon) {
      this.loadPolygon(this.polygon!);
      this.selectFeatures(this.selected);
    }
    
    if (this.showMapBiomasIcon) {
      this.placeControl(
        this.$refs.mapBiomas as HTMLElement,
        window.google.maps.ControlPosition.RIGHT_BOTTOM
      );
    }
  }

  private initCoordinatesLabel(element: HTMLElement) {
    this.placeControl(element, window.google.maps.ControlPosition.RIGHT_TOP);
    this.registerListener(
      this.wrappedMap!.addListener("mousemove", (event) => {
        this.displayCoordinates(event.latLng);
      })
    );
  }

  private placeMapControls() {
    this.placeControl(
      this.$refs.mapControls as HTMLElement,
      window.google.maps.ControlPosition.RIGHT_CENTER
    );
  }

  private boundToPolygon() {
    const bounds = new window.google.maps.LatLngBounds();

    this.wrappedMap!.data.forEach((feature) => {
      feature.getGeometry().forEachLatLng((latLng) => {
        bounds.extend(latLng);
      });
    });

    if (!bounds.isEmpty()) {
      this.wrappedMap!.fitBounds(bounds);
      this.lastBoundedSize = this.lastSize;
    }
  }

  private addFitBoundsListener() {
    this.ro = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const minSize = Math.min(width, height);

        if (this.loaded && this.mapSignal && this.lastBoundedSize === 0 && minSize !== 0) {
          this.boundToPolygon();
          this.mapSignal = false;
        }

        this.lastSize = minSize;
      }
    })
    this.ro.observe(this.$refs.mapElement as HTMLDivElement);
  }

  private addHandlerSelectFeature() {
    this.registerListener(this.wrappedMap!.data.addListener('click',  (evt: google.maps.Data.MouseEvent) => {
      if (this.selectable) {
        this.toggleFeature(evt.feature);
      }
    }));
  }

  private toggleFeature(feature: google.maps.Data.Feature) {
    const featureId = feature.getProperty(this.idProperty!);
    let promise: Promise<unknown>;
    if (this.featuresSelectedSet.has(featureId)) {
      this.wrappedMap!.data.revertStyle(feature);

      promise = Promise.resolve().then(() => {
        this.featuresSelected = this.featuresSelected.filter(fid => (fid !== featureId));
        this.featuresSelectedSet.delete(featureId);
        this.$emit('deselect:feature', featureId);
      })
    } else {
      this.wrappedMap!.data.overrideStyle(feature, { strokeColor: 'yellow', strokeWeight: 5 });

      promise = Promise.resolve().then(() => {
        this.featuresSelected.push(featureId);
        this.featuresSelectedSet.add(featureId);
        this.$emit('select:feature', featureId);
      });
    }

    promise.then(() => {
      this.$emit('update:selected', this.featuresSelected);
    })
  }

  private async selectFeatures(features: any[]) {
    const featuresSet = new Set(features);
    const promises: Array<Promise<unknown>> = [];

    this.wrappedMap!.data.forEach(feature => {
      promises.push(Promise.resolve().then(() => {
        const featureId = feature.getProperty(this.idProperty!);
        if (featuresSet.has(featureId) && !this.featuresSelectedSet.has(featureId)) {
          this.wrappedMap!.data.overrideStyle(feature, { strokeColor: 'yellow', strokeWeight: 5 });
        } else if (!featuresSet.has(featureId) && this.featuresSelectedSet.has(featureId)) {
          this.wrappedMap!.data.revertStyle(feature);
        }
      }));
    })

    return Promise.all(promises).then(() => {
      this.featuresSelected = features;
      this.featuresSelectedSet = featuresSet;
    });
  }

  @Watch('selected')
  private async changedSelected(features: any[]) {
    if (!!this.wrappedMap) {
      await this.selectFeatures(this.selected);
    }
  }

  private setupPolygonStyle() {
    requestAnimationFrame(() => {
      this.wrappedMap!.data.setStyle(feature => {
        const fillColor = feature.getProperty('fill') || "#555555";
        const fillOpacity = feature.getProperty('fill-opacity') || 0.5;
        const strokeColor = feature.getProperty('stroke') || "#555555";
        const strokeOpacity = feature.getProperty('stroke-opacity') || 1.0;
        const strokeWeight = feature.getProperty('stroke-width') || 2;
        const isClickable = feature.getProperty('id') !== null;

        return {
          clickable: isClickable,
          fillColor,
          fillOpacity,
          strokeColor,
          strokeOpacity,
          strokeWeight,
        };
      });
    });
  }

  private loadPolygon(polygon: GeoJSON.GeoJSON, idPropertyName = 'id', insertLabels = true) {
      this.wrappedMap!.data.addGeoJson(polygon, {
        idPropertyName: idPropertyName,
      });

      this.boundToPolygon();
      this.mapSignal = true;

      if (!!this.labelProperty && insertLabels) {
        this.insertLabels();
      }
  }

  private removePolygon() {
    this.wrappedMap!.data.forEach(feature => {
      this.wrappedMap!.data.remove(feature);
    });
  }

  @Watch('polygon')
  private async changedPolygon(polygon?: GeoJSON.GeoJSON, oldPolygon?: GeoJSON.GeoJSON) {
    if (!!this.wrappedMap) {
      this.removePolygon();
      this.removeLabels();
      if (!!polygon) {
        this.loadPolygon(polygon);
        await this.selectFeatures(this.selected);
      }
    }
  }

  @Watch('labelProperty')
  private changedLabel(labelProperty?: string) {
    if (!!this.wrappedMap) {
      this.removeLabels();
      if (!!labelProperty) {
        this.insertLabels();
      }
    }
  }

  private createLabel(position: google.maps.LatLng, title: string) {
    return new window.google.maps.Marker({
      position,
      draggable: false,
      label: {
        text: title,
        color: '#fff',
      },
      clickable: false
    });
  }


  private insertLabels() {
    requestAnimationFrame(() => {
      if (!this.showLabel) { return; }

      const attachedLabels: google.maps.Marker[] = [];
      const promises: Array<Promise<unknown>> = []

      this.wrappedMap!.data.forEach((feature) => {
        if (feature.getId() != null && !feature.getId().toString().startsWith('extraPolygons')) {
          promises.push(Promise.resolve().then(() => {
            const bounds = new window.google.maps.LatLngBounds();
            const label = feature.getProperty(this.labelProperty!);
            if (!!label) {
              feature.getGeometry().forEachLatLng(latLng => {
                bounds.extend(latLng);
              });
              attachedLabels.push(this.createLabel(bounds.getCenter(), `${label}`));
            }
          }));
        }
      })
      Promise.all(promises).then(() => {
        this.attachedLabelsCluster = new MarkerClustererPlus(this.wrappedMap!, attachedLabels, {
          imagePath: `${process.env.BASE_URL}assets/marker-icons/m`,
        });
      })
    });
}

  private removeLabels() {
    if (!!this.attachedLabelsCluster) {
      this.attachedLabelsCluster!.clearMarkers();
      this.attachedLabelsCluster = null;
    }
  }

  private changeVisibility(visible: boolean) {
    if (visible) {
      this.insertLabels();
    } else {
      this.removeLabels();
    }
  }

  private toggleLabel() {
    metadataService.toggleMarkerLabel();
  }
  
  private zIndexChange() {
    this.imageZIndex = this.imageZIndex == 2 ? 20000 : 2;
    
  }

  @Watch('showLabel')
  private changedLabelVisibility(showLabel: boolean) {
    this.changeVisibility(showLabel);
  }

  @Emit('download:geojson')
  private downloadAsGeoJson(polygon: GeoJSON.GeoJSON) {}

  private registerListener(listener: google.maps.MapsEventListener) {
    this.listeners.push(listener);
  }

  private unregisterListeners() {
    this.listeners.forEach((listener) => {
      window.google.maps.event.removeListener(listener);
    });
  }

  private placeControl(
    element: HTMLElement,
    position: google.maps.ControlPosition
  ) {
    this.wrappedMap!.controls[position].push(element);
  }

  private displayCoordinates(pnt: google.maps.LatLng) {
    const lat = pnt.lat().toFixed(4);
    const lng = pnt.lng().toFixed(4);
    this.coordinatesString = this.$t("core.wrapped-gm.latLngLabel", {
      lat,
      lng,
    }) as string;
  }


  private zoomIn() {
    if (!!this.wrappedMap) {
      this.wrappedMap.setZoom(this.wrappedMap.getZoom() + 1);
    }
  }

  private zoomOut() {
    if (!!this.wrappedMap) {
      this.wrappedMap.setZoom(this.wrappedMap.getZoom() + -1);
    }
  }
  
  public showPlots(event: any) {
    requestAnimationFrame(() => {
      this.wrappedMap!.data.forEach((feature) => {
        if (feature.getProperty("type") == 'FARM') {
          feature.setProperty("fill-opacity", event.visible ? 0.2 : 0.001);
        }
        
        if (event.cropTypes.includes(feature.getProperty("crop_type")) && feature.getProperty("type") == 'CROP') {
          feature.setProperty("fill-opacity", event.visible ? 0.6 : 0.001);
          feature.setProperty("stroke-width", event.visible ? 1.0 : 0.50);
        }
      })
    });
  }

  private beforeDestroy() {
    this.unregisterListeners();
    if (!!this.ro) {
      this.ro.disconnect();
    }

    if (!!this.rvo) {
      this.rvo.disconnect();
      this.rvo = null;
    }
  }
}
